module.exports = __webpack_public_path__ + "img/pickiddologolargesize.133de08d.png";